import { WebGLCubeRenderTarget, WebGLRenderTargetOptions } from '../../thirdparty/three/imports';

export class WebGLCubeRenderTarget3D
{
    _target: WebGLCubeRenderTarget;

    get texture()
    {
        return this._target.texture;
    }
    set texture(v)
    {
        this._target.texture = v;
    }

    constructor(size = 1, options: WebGLRenderTargetOptions = {})
    {
        this._target = new WebGLCubeRenderTarget(size, options);
    }
}
